import { CommonHelperFunctions, ICheckoutDto, IUpdateSubscriptionDto, IUserDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class PaymentService {
  public static async Checkout(checkout: ICheckoutDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IUserDto, AxiosResponse>(`${backendUrl}/Payment/checkout`, checkout);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async CancelSubscription(): Promise<AxiosResponse> {
    try {
      return await Axios.post<IUserDto, AxiosResponse>(`${backendUrl}/Payment/cancelsubscription`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetCurrentSubscription(): Promise<AxiosResponse> {
    try {
      return await Axios.post<IUserDto, AxiosResponse>(`${backendUrl}/Payment/currentsubscription`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetNextSubscription(): Promise<AxiosResponse> {
    try {
      return await Axios.post<IUserDto, AxiosResponse>(`${backendUrl}/Payment/nextsubscription`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async UpdateSubscription(checkout: IUpdateSubscriptionDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IUserDto, AxiosResponse>(`${backendUrl}/Payment/updatesubscription`, checkout);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async UpdateSeatInfo(checkout: IUpdateSubscriptionDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IUserDto, AxiosResponse>(`${backendUrl}/Payment/updateseatinfo`, checkout);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
